import { QuotePrintController as controller } from './quote-print.controller'

export const QuotePrintComponent = {
  template: `
  <div>
    <div ng-bind-html="$ctrl.renderedTemplate"></div>
  </div>
  `,
  controller,
  bindings: {
    data: '=',
    options: '=',
  },
}
